'use client';

import { useTour } from '@reactour/tour';
import { useTranslations } from '@power-core/toolkit';
import type { FunctionComponent } from 'react';

import { useAppContext } from '@/modules/app-context/use-app-context';
import { ProjectFiles } from '@/modules/project/components/project-files/project-files';
import { ProjectHistory } from '@/modules/project/components/project-history/project-history';
import { useDevice } from '@/modules/utils/custom-hooks/use-device';
import { Tabs } from '@/ui-components/tabs/tabs';

export const ProjectContent: FunctionComponent = () => {
	const t = useTranslations();
	const { isOpen } = useTour();
	const { isLaptop, isMobile } = useDevice();
	const { project, projectContentTabIndex, setProjectContentTabIndex } = useAppContext();

	const setProjectTitle = (stringKey1: string, stringKey2: string) => {
		const sliceLength = isMobile ? 10 : 30;
		const shouldBeSliced = project?.title && project?.title.length > sliceLength;

		return project?.title ? `${project?.title.slice(0, sliceLength)} ${shouldBeSliced ? '...' : ''} ${stringKey1}` : stringKey2;
	};

	const tabs = [
		{ title: setProjectTitle(t('T_FILES'), t('T_PROJECT_FILES')), content: <ProjectFiles /> },
		{ title: setProjectTitle(t('T_HISTORY'), t('T_PROJECT_HISTORY')), content: <ProjectHistory /> },
	];

	const renderContent = () => {
		if (isLaptop)
			return (
				<Tabs
					tabs={tabs}
					activeTabIndex={projectContentTabIndex}
					setActiveTabIndex={setProjectContentTabIndex}
					containerClassname='grid grid-rows-[auto,1fr]'
					titleSize='text-base'
				/>
			);

		return (
			<>
				<div className='col-span-1 step-3'>
					<ProjectFiles />
				</div>
				<div className='col-span-1 step-4 step-3'>
					<ProjectHistory />
				</div>
			</>
		);
	};

	return (
		<div
			className={`col-span-12 grid ${isLaptop ? 'grid-cols-1' : 'grid-cols-2'} gap-4 ${!project?.documentId && !isOpen ? 'blur-md' : ''}`}
		>
			{renderContent()}
		</div>
	);
};
